//#region IGlobalStockTag
export interface IGlobalStockTag {
  global: boolean;
  name: string;
}

//#endregion
